import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// window.url =  "https://api.swarnbhoomii.com/crm/";
// window.url =  "https://api.swarnbhoomii.com/demo-crm/";
// window.url =  "http://localhost/api/";   

window.url = "https://api.novaleapsolution.com/";
// window.url =  "http://localhost/api/";
// window.url = "https://dipeshsaini.com/api/demo-crm/";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
